import { apiClient } from './client';

/**
 * Get course analytics overview
 * @param {string} courseId
 * @param {{ startDate?, endDate? }} params  inclusive YYYY-MM-DD days; narrows to the students who
 *   enrolled (and the orders paid) in that window
 * @returns {{ totalEnrollments, activeEnrollments, completedEnrollments, totalRevenue, avgCompletion }}
 */
export async function getCourseAnalytics(courseId, params = {}) {
  const { data } = await apiClient.get(`/analytics/courses/${courseId}`, { params });
  return data;
}

/**
 * Get per-lesson completion for a course
 * @param {string} courseId
 * @param {{ startDate?, endDate? }} params  same window as getCourseAnalytics
 * @returns {{ lessons: Array<{ lessonId, title, sequenceIndex, completionRate, studentsStarted,
 *   studentsCompleted, averageTime }> }}  averageTime is minutes
 */
export async function getCourseLessonCompletion(courseId, params = {}) {
  const { data } = await apiClient.get(`/analytics/courses/${courseId}/lessons/completion`, { params });
  return data;
}

/**
 * Get course drop-off analysis
 * @param {string} courseId
 * @returns {{ dropOffLessons: Array<{ lessonId, title, studentsThatDropped, dropOffRate }> }}
 */
export async function getCourseDropOff(courseId) {
  const { data } = await apiClient.get(`/analytics/courses/${courseId}/drop-off`);
  return data;
}

/**
 * Export course analytics
 * @param {string} courseId
 * @param {{ format?, includeStudents?, includeLessons?, startDate?, endDate? }} params
 */
export async function exportCourseAnalytics(courseId, params = {}) {
  const { data } = await apiClient.get(`/analytics/courses/${courseId}/analytics/export`, {
    params,
    responseType: 'blob'
  });
  return data;
}
